/** Eksport pakej kes, kuasa peringkat dan kunci tandatangan pakej (Fasa 2 P2-3). */
export default {
  export: {
    title: 'Pakej kes',
    open: 'Eksport pakej',
    intro:
      'Pakej kes membawa seluruh sejarah serahan ini sebagai satu fail bertandatangan yang boleh disemak dan diimport oleh sistem lain.',
    profile: 'Kandungan',
    profiles: {
      full: 'Rekod penuh',
      interagency: 'Untuk agensi lain (tanpa butiran hubungan pemohon)',
      party: 'Untuk pemohon',
      public: 'Awam (tanpa data peribadi)',
      archive: 'Arkib (semua, termasuk laporan semakan dan prosedur)',
    },
    boundary: 'Titik serahan',
    boundaries: {
      submission: 'Serahan',
      supplement_withdraw: 'Tambahan atau penarikan balik',
      referral: 'Rujukan kepada agensi',
      forward: 'Majukan kepada pihak berkuasa lain',
      decision: 'Keputusan',
      post_decision: 'Selepas keputusan',
      register: 'Daftar atau statistik',
      snapshot: 'Keadaan semasa (tiada serahan)',
    },
    recipient: 'Sistem penerima',
    recipientHint: 'Pengenal yang anda gunakan untuk sistem penerima, dalam huruf kecil, contohnya mbjb-osc.',
    recipientInvalid: 'Gunakan huruf kecil, digit, titik, sengkang atau garis bawah, bermula dengan huruf atau digit.',
    forwardWarning:
      'Memajukan menyerahkan serahan ini kepada sistem penerima. Tiada apa-apa boleh diubah di sini sehingga pentadbir menariknya balik.',
    start: 'Cipta pakej',
    status: {
      queued: 'Menunggu untuk bermula…',
      running: 'Sedang membina pakej…',
      done: 'Pakej sudah sedia.',
      failed: 'Pakej tidak dapat dibina.',
      expired: 'Pakej telah tamat tempoh dan dipadam. Cipta semula.',
    },
    download: 'Muat turun pakej',
    close: 'Tutup',
    asAt: 'Sejarah sehingga peristiwa {{seq}}',
    errors: {
      EXPORT_FAILED: 'Berlaku ralat semasa membina pakej. Cuba lagi.',
      EXPORT_CHAIN_BROKEN: 'Sejarah serahan ini gagal disahkan, jadi ia tidak boleh dieksport.',
      EXPORT_DOCUMENT_MISSING: 'Satu fail serahan ini tiada dalam storan.',
      EXPORT_DOCUMENT_MISMATCH: 'Fail yang disimpan tidak lagi sepadan dengan sejarah.',
      EXPORT_REPORT_MISMATCH: 'Laporan semakan tidak lagi sepadan dengan sejarah.',
      EXPORT_LETTER_INPUT_MISMATCH: 'Satu fail surat keputusan tidak lagi sepadan dengan sejarah.',
      EXPORT_PUBLIC_UNSAFE:
        'Sejarah serahan ini mengandungi data peribadi dalam teks biasa, jadi pakej awam tidak boleh dibuat.',
      EXPORT_TOO_LARGE: 'Pakej akan melebihi 4 GB.',
      EXPORT_SEAL_KEY_UNAVAILABLE:
        'Kunci tandatangan pakej tidak boleh digunakan. Pentadbir perlu menggantikannya di Tetapan → Perancangan.',
      EXPORT_GEOMETRY_FAILED: 'Tapak tidak dapat dibaca daripada daftar peta.',
      EXPORT_BOUNDARY_NOT_REACHED: 'Serahan ini belum sampai ke titik serahan itu.',
      EXPORT_SEAL_KEY_REVOKED:
        'Kunci yang menandatangani pakej ini telah dibatalkan. Cipta pakej semula supaya ditandatangani dengan kunci baharu.',
      EXPORT_STALE: 'Pembinaan pakej terhenti tanpa diduga. Cipta semula.',
    },
  },
  authority: {
    heldTitle: 'Dipegang oleh sistem lain',
    heldBody:
      'Serahan ini telah dimajukan kepada {{holder}} pada {{date}}. Tindakan di sini ditolak sehingga ia ditarik balik.',
    heldBodyUnnamed:
      'Serahan ini telah dimajukan kepada sistem lain pada {{date}}. Tindakan di sini ditolak sehingga ia ditarik balik.',
    recall: 'Tarik balik',
    recallTitle: 'Tarik balik serahan ini',
    recallBody:
      'Ambil semula serahan daripada {{holder}}. Maklumkan kepada sistem penerima bahawa anda telah berbuat demikian.',
    reasonLabel: 'Sebab',
    reasonRequired: 'Masukkan sebab.',
    confirm: 'Tarik balik serahan',
    cancel: 'Batal',
  },
  sealKey: {
    title: 'Kunci tandatangan pakej',
    description:
      'Pakej kes ditandatangani dengan kunci ini. Sistem penerima menyemak tandatangan dengan senarai kunci yang diterbitkan.',
    active: 'Kunci yang digunakan: {{kid}}',
    created: 'Dicipta {{date}}',
    none: 'Belum ada kunci. Satu kunci dicipta bersama pakej pertama.',
    retired: 'Kunci terdahulu, masih diterbitkan supaya pakej terdahulu masih boleh disahkan',
    jwksUrl: 'Alamat senarai kunci',
    copy: 'Salin alamat',
    copied: 'Disalin',
    download: 'Muat turun senarai kunci',
    rotate: 'Ganti kunci',
    rotateConfirm:
      'Ganti kunci tandatangan? Pakej baharu ditandatangani dengan kunci baharu; kunci lama kekal diterbitkan.',
    rotated: 'Kunci tandatangan telah diganti.',
    cancel: 'Batal',
    revokePrevious:
      'Kunci lama mungkin telah bocor: batalkannya, supaya apa-apa yang ditandatanganinya tidak lagi boleh disahkan',
    revokeConfirm:
      'Ganti kunci tandatangan dan batalkan kunci lama? Kunci itu tidak lagi diterbitkan, jadi apa-apa yang ditandatanganinya tidak lagi boleh disahkan, dan setiap pakej siap yang ditandatanganinya perlu dicipta semula.',
    revoked: 'Kunci yang dibatalkan, tidak lagi diterbitkan',
  },
  errors: {
    invalid_export: 'Pilihan eksport itu tidak sah.',
    public_export_unsafe:
      'Sejarah serahan ini mengandungi data peribadi dalam teks biasa, jadi pakej awam tidak boleh dibuat.',
    boundary_not_reached: 'Serahan ini belum sampai ke titik serahan itu. Eksport keadaannya sekarang.',
    stage_held_externally: 'Sistem lain memegang serahan ini. Pentadbir perlu menariknya balik dahulu.',
    not_held_externally: 'Tiada sistem lain yang memegang serahan ini.',
    intake_in_progress: 'Semakan lukisan masih berjalan. Majukan serahan selepas semakan selesai.',
    export_not_found: 'Pakej itu tidak dijumpai.',
    export_not_ready: 'Pakej itu belum sedia.',
    export_expired: 'Pakej itu telah tamat tempoh dan dipadam. Cipta semula.',
    too_many_exports: 'Anda sudah mempunyai tiga pakej yang sedang dibina. Tunggu satu selesai.',
  },
  events: {
    case_authority_transferred: 'Dimajukan kepada sistem lain',
    case_authority_returned: 'Diambil semula daripada sistem lain',
  },
} as const
